import { faChevronRight, faWind } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import SmokingTracker from './SmokingTracker';

function PhysicalWBCover(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openSmoking, setOpenSmoking] = useState(false);

  const handleSmoking = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenSmoking(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openSmoking) {
      const smoking = document.getElementById('snm-smoking');
      setTimeout(() => {
        smoking?.classList.add('slide-in');
      }, 300);
    }
  }, [openSmoking]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  const handleBackToMain = () => {
    if (openSmoking) {
      const smoking = document.getElementById('snm-smoking');
      smoking?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenSmoking(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleSmoking}
              type="button"
              aria-label={t('T355')}
            >
              <div>
                <FontAwesomeIcon icon={faWind} className="mood-icon" /> {t('T355')}{' '}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openSmoking && (
        <SmokingTracker handleBackToMain={handleBackToMain} closeTrackers={closeTrackers} />
      )}
    </>
  );
}
export default PhysicalWBCover;
